export const DEFAULT_COUNTRY = 'US'
export const DEFAULT_COUNTRY_CODE = 1
export const DEFAULT_CURRENCY_CODE = 'USD'
export const MAX_TRANSACTIONS_NUMBER = 3
export const RECENT_ACTIVITY_LENGTH = 5
export const MAX_DOCS_NUMBER = 3
export const APP_LANGUAGE = 'en-US'
export const FINXACT_TIMEZONE = 'America/New_York'
export const PIN_INPUT_ID = 'pin-input'
export const TOAST_CONTAINER_ID = 'evergreen-toast-container'
export const MODAL_CONTAINER_ID = 'evergreen-modal'
export const REDIRECT_AFTER_SIGN_IN_URL_PARAM = 'redirect-url'
// EMPTY_VARIABLE
export const _ = undefined

// EMPTY FUNCTION
export const NOOP = (): void => {
  // INTENTIONALLY LEFT EMPTY
}
